<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="cycle-tickets-header">
	<div class="cycle-tickets-header-text">{{ AppStrings.CYCLE_TICKETS }}</div>
	<div class="cycle-tickets-control">
		<span
			class="cycle-tickets-arrow"
			automationId="cycleTicketsArrowPrevious"
			[ngClass]="{ 'disabled-arrow': disableCycleButtons$ | async }"
			(click)="previousTicket()"
			><i class="material-icons">chevron_left</i></span
		>
		<span class="cycle-tickets-display" automationId="cycleTicketsCount"
			>{{ currentTicketIndex + 1 }}/{{ numTickets }}</span
		>
		<span
			class="cycle-tickets-arrow"
			automationId="cycleTicketsArrowNext"
			[ngClass]="{ 'disabled-arrow': disableCycleButtons$ | async }"
			(click)="nextTicket()"
			><i class="material-icons">chevron_right</i></span
		>
	</div>
</div>
<div class="cycle-ticket-label" *ngIf="fullMenu">{{ AppStrings.TAP_TICKET_BELOW_TO_EDIT }}</div>
<div
	class="cycle-tickets-content"
	[ngClass]="{ 'cycle-tickets-clickable': fullMenu }"
	(click)="fullMenu && openEdit()"
>
	<div [ngSwitch]="ticket.view.type" class="role-icon-container">
		<div
			*ngSwitchCase="'milestone'"
			[ngStyle]="{ 'background-color': getTicketColor() }"
			class="cycle-tickets-role-milestone"
		></div>
		<div
			*ngSwitchCase="'constraint'"
			[ngStyle]="{ 'background-color': getTicketColor() }"
			class="cycle-tickets-role-constraint"
		>
			<img
				*ngIf="ticket.view.isActualized"
				class="cycle-tickets-role-constraint-actualized"
				src="assets/images/fancycanvas/src/ticket-checkmark.png"
				alt="completed check"
			/>
		</div>
		<div
			*ngSwitchDefault
			[ngStyle]="{ 'background-color': getTicketColor() }"
			class="cycle-tickets-role-ticket"
		></div>
	</div>
	<div class="cycle-tickets-details">
		<div class="cycle-tickets-activity-name" automationId="cycleTicketTitle">
			{{ ticket.view.activityName }}
		</div>
		<div class="cycle-tickets-location-container">
			<i
				[ngStyle]="{ color: ticket.view.location ? ticket.view.location.view.color : 'initial' }"
				class="material-icons location-icon"
				>location_on</i
			>
			<div class="cycle-tickets-location">
				{{ ticket.view.location ? ticket.view.location.view.name : 'None' }}
			</div>
		</div>
	</div>
</div>
